import type { ParentProps } from 'solid-js'
import Calendar from './Calendar'

function Container(props: ParentProps) {
  return <main>
    {props.children}
  </main>
}

const routes = [
  {
    path: '/events',
    component: Container,
    children: [
      {
        path: '/',
        component: Calendar,
      },
    ],
  },
]

export default routes
